import {all, call, put} from 'redux-saga/effects'
import authSaga from "./auth";
import rewardsSaga from "./rewards";
import rewardClaimsSaga from "./rewardClaims";
import rewardClaimOptionsSaga from "./rewardClaimOptions";
import ordersSaga from "./orders";
import formTemplateSaga from "./formTemplate"

export default function* rootSaga() {
    yield all([
        call(authSaga),
        call(rewardsSaga),
        call(rewardClaimsSaga),
        call(ordersSaga),
        call(rewardClaimOptionsSaga),
        call(formTemplateSaga)
    ]);
}

export function* handleError(error, messageKey = null) {
    yield put({
        type: "ERROR",
        error,
        messageKey
    });
}

export function* executeAxiosWithExceptionHandling(call) {
    try {
        return yield call();
    } catch (e) {
        handleAxiosException(e);
    }
}

export function handleAxiosException(exception) {
    if (exception && exception.response && exception.response.status === 500) {
        let error = new Error(exception.response.data.message);
        error['errorCode'] = exception.response.data.errorCode;
        error['type'] = "INTERNAL_SERVER_ERROR";
        throw error;
    } else
        throw exception;
}
